export default "__VITE_ASSET__PWDifo$E__"